export class GLOBAL {
    public static CONTENT_TYPE = 'Content-Type'
    public static APPLICATION_TYPE_JSON = 'application/json; charset=utf-8'
    public static MULTIPART_FORM_DATA = 'multipart/form-data'// 'application/x-www-form-urlencoded'
    public static BEARER = 'Bearer '
    public static AUTHORIZATION = 'Authorization'
    public static PREVIOUS_URL = 'previousUrl'
}
